import { render } from "./footer.vue?vue&type=template&id=51b3be7a"
const script = {}

import exportComponent from "D:\\Assets\\pythonScripts\\bushmanFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__